import React from 'react';
import AdvancedMyCompaniesModal from './AdvancedMyCompaniesModal';

interface MyCompaniesModalProps {
  open: boolean;
  onClose: () => void;
}

const MyCompaniesModal: React.FC<MyCompaniesModalProps> = ({ open, onClose }) => {
  return <AdvancedMyCompaniesModal open={open} onClose={onClose} />;
};

export default MyCompaniesModal;